import { useRescreenDealLead } from '@/hooks/use-deal-leads'
import { showError, showInfo } from '@/lib/toast'

export function useScreenAgain(leadId: string) {
  const rescreen = useRescreenDealLead(leadId)

  const run = () => {
    rescreen.mutate(leadId, {
      // The call returns once queued; screening runs for tens of seconds after.
      onSuccess: () =>
        showInfo('Screening again. The verdict will update here.'),
      onError: (error) =>
        showError(error, 'This lead could not be screened again.'),
    })
  }

  return { run, isPending: rescreen.isPending }
}
